import { render, staticRenderFns } from "./NuevoCliente.vue?vue&type=template&id=3fc84941&"
import script from "./NuevoCliente.vue?vue&type=script&lang=js&"
export * from "./NuevoCliente.vue?vue&type=script&lang=js&"
import style0 from "./NuevoCliente.vue?vue&type=style&index=0&id=3fc84941&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports